import './locales/register'
import { lazy, ReactNode, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { Loading } from '@vnetwork/datacentral-ui/feedback'
import OperationsAccessGuard from './components/access-guard'

const Dashboard = lazy(() => import('./components/Dashboard'))
const Services = lazy(() => import('./components/Services'))
const ServiceDetail = lazy(() => import('./components/ServiceDetail'))
const Resources = lazy(() => import('./components/Resources'))
const Cdn = lazy(() => import('./components/Cdn'))
const Orgs = lazy(() => import('./components/Orgs'))
const OrgDetail = lazy(() => import('./components/OrgDetail'))

const guarded = (page: ReactNode) => (
    <OperationsAccessGuard>
        <Suspense fallback={<Loading />}>{page}</Suspense>
    </OperationsAccessGuard>
)

const OperationsModule: RouteObject = {
    path: 'operations',
    children: [
        { path: '', element: guarded(<Dashboard />) },
        { path: 'services', element: guarded(<Services />) },
        { path: 'services/:id', element: guarded(<ServiceDetail />) },
        { path: 'resources', element: guarded(<Resources />) },
        { path: 'orgs', element: guarded(<Orgs />) },
        { path: 'orgs/:orgId', element: guarded(<OrgDetail />) },
        { path: 'cdn', element: guarded(<Cdn />) },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default OperationsModule
